var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"eye-dropper",style:({
    transform: ("translate(" + _vm.xCoord + "px, " + _vm.yCoord + "px)")
  })},[_c('div',{staticClass:"review-color",style:({
      backgroundColor: _vm.color
    })})])}
var staticRenderFns = []

export { render, staticRenderFns }